// import React from 'react';

// const TermsOfService: React.FC = () => (
//   <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-masa-blue/10 px-4">
//     <div className="bg-white/90 border border-masa-blue/20 rounded-2xl shadow-xl p-10 max-w-lg w-full text-center">
//       <div className="flex justify-center mb-6">
//         <span className="inline-block w-16 h-1 bg-gradient-to-r from-masa-coral via-masa-yellow via-masa-teal via-masa-blue to-masa-magenta rounded-full"></span>
//       </div>
//       <h1 className="text-3xl md:text-4xl font-bold mb-4 text-masa-dark">
//         Page Under Maintenance
//       </h1>
//       <p className="text-lg text-masa-blue font-semibold mb-2">Coming Soon!</p>
//       <p className="text-gray-600 mb-6">We're working hard to bring you this page. Please check back later.</p>
//       <div className="flex items-center justify-center space-x-2 mt-4">
//         <span className="w-3 h-3 bg-masa-coral rounded-full"></span>
//         <span className="w-3 h-3 bg-masa-yellow rounded-full"></span>
//         <span className="w-3 h-3 bg-masa-teal rounded-full"></span>
//         <span className="w-3 h-3 bg-masa-blue rounded-full"></span>
//         <span className="w-3 h-3 bg-masa-magenta rounded-full"></span>
//       </div>
//     </div>
//   </div>
// );

// export default TermsOfService;

import React from 'react';
import { FileText, AlertTriangle, Phone, Mail, MapPin, Scale } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
          <div className="flex items-center mb-6">
            <Scale className="h-8 w-8 text-blue-600 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          </div>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-blue-800 font-semibold">Masa Hills Health Services</p>
            <p className="text-blue-700">Effective Date: June 8, 2025</p>
          </div>
        </div>

        {/* Table of Contents */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
            <FileText className="h-5 w-5 mr-2" />
            Table of Contents
          </h2>
          <nav className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <a href="#acceptance" className="text-blue-600 hover:text-blue-800 hover:underline">1. Acceptance of Terms</a>
            <a href="#medical-disclaimer" className="text-blue-600 hover:text-blue-800 hover:underline">2. Medical Disclaimer</a>
            <a href="#services" className="text-blue-600 hover:text-blue-800 hover:underline">3. Website Services</a>
            <a href="#privacy" className="text-blue-600 hover:text-blue-800 hover:underline">4. Privacy & Health Information</a>
            <a href="#conduct" className="text-blue-600 hover:text-blue-800 hover:underline">5. User Conduct</a>
            <a href="#intellectual-property" className="text-blue-600 hover:text-blue-800 hover:underline">6. Intellectual Property</a>
            <a href="#third-party" className="text-blue-600 hover:text-blue-800 hover:underline">7. Third-Party Links</a>
            <a href="#warranties" className="text-blue-600 hover:text-blue-800 hover:underline">8. Disclaimer of Warranties</a>
            <a href="#liability" className="text-blue-600 hover:text-blue-800 hover:underline">9. Limitation on Liability</a>
            <a href="#governing-law" className="text-blue-600 hover:text-blue-800 hover:underline">10. Governing Law</a>
            <a href="#changes" className="text-blue-600 hover:text-blue-800 hover:underline">11. Changes to Terms</a>
            <a href="#contact" className="text-blue-600 hover:text-blue-800 hover:underline">12. Contact Information</a>
          </nav>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 space-y-8">
          
          {/* Section 1 */}
          <section id="acceptance">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of the Terms of Service</h2>
            <div className="prose prose-gray max-w-none space-y-4">
              <p>Welcome to www.masahillshealthservices.com (the "Site"), owned and operated by Masa Hills Health Services ("we," "us," "our," or the "Practice"). The following terms and conditions ("Terms of Service") govern your access to and use of our Site, including any content, functionality, and services offered on or through the Site.</p>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="text-yellow-800 font-medium">Please read these Terms of Service carefully before you start to use the Site. By accessing, browsing, or using the Site, you acknowledge that you have read, understood, and agree to be bound and abide by these Terms of Service and our Privacy Policy, which is incorporated herein by reference.</p>
              </div>
              
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-red-800 font-medium">If you do not agree to these Terms of Service or the Privacy Policy, you must not access or use the Site.</p>
              </div>
              
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-blue-800"><strong>Age Requirement:</strong> This Site is offered and available to users who are 18 years of age or older and reside in the United States. By using this Site, you represent and warrant that you are of legal age to form a binding contract with the Practice and meet all of the foregoing eligibility requirements.</p>
              </div>
            </div>
          </section>

          {/* Section 2 */}
          <section id="medical-disclaimer">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <AlertTriangle className="h-6 w-6 text-red-600 mr-2" />
              2. IMPORTANT MEDICAL DISCLAIMER
            </h2>
            <div className="space-y-4">
              <div className="bg-red-100 border-2 border-red-300 rounded-lg p-6">
                <h3 className="text-xl font-bold text-red-900 mb-4 text-center">THIS SITE DOES NOT PROVIDE MEDICAL ADVICE</h3>
                <div className="space-y-3 text-red-800">
                  <p>The content on this Site, including but not limited to text, graphics, images, and other material, is for informational purposes only. The content is not intended to be a substitute for professional medical advice, diagnosis, or treatment.</p>
                  <p>Using this Site or communicating with us through this Site does not establish a doctor-patient or therapist-client relationship. A formal relationship is only established after you have completed our intake process and have been accepted as a patient by our Practice.</p>
                  <p><strong>Always seek the advice of your physician or another qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of something you have read on this Site.</strong></p>
                </div>
              </div>
              
              <div className="bg-red-600 text-white rounded-lg p-6 text-center">
                <h3 className="text-xl font-bold mb-2">EMERGENCY NOTICE</h3>
                <p className="font-semibold">IF YOU THINK YOU MAY HAVE A MEDICAL EMERGENCY, CALL YOUR DOCTOR OR 911 IMMEDIATELY.</p>
                <p className="mt-2">We do not monitor requests or communications in real-time. Do not use this Site for emergency medical needs.</p>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section id="services">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Description of Website Services</h2>
            <div className="space-y-4">
              <p>The Site is designed to provide you with information about our health services, providers, locations, and other health-related topics. It also provides methods for you to contact us to ask questions or request an appointment. We do not guarantee that the information provided is exhaustive, complete, or up to date. All information is subject to change without notice.</p>
              
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <h3 className="font-semibold text-green-900 mb-2">Texas DTPA Compliance</h3>
                <p className="text-green-800">In compliance with the Texas Deceptive Trade Practices Act (DTPA), we will not misrepresent our services, their characteristics, or their benefits. The information on this Site is a representation of our practice and services, not a warranty or guarantee of specific outcomes.</p>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section id="privacy">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Privacy and Protection of Health Information</h2>
            <div className="space-y-4">
              <p>Your use of the Site is also governed by our Privacy Policy & Notice of Privacy Practices, which outlines our practices for collecting, using, and protecting your information, including your Protected Health Information (PHI) under the Health Insurance Portability and Accountability Act (HIPAA) and Texas law.</p>
              
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                <h3 className="font-semibold text-orange-900 mb-2">Security Notice</h3>
                <p className="text-orange-800">You acknowledge that any information submitted through general contact forms on the Site may not be fully secure. You should not send sensitive, confidential, or urgent medical information through these general channels. Secure communication methods will be provided to you after you become an established patient of the Practice.</p>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section id="conduct">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. User Conduct and Responsibilities</h2>
            <div className="space-y-4">
              <p>You agree to use the Site only for lawful purposes and in accordance with these Terms of Service. You agree not to:</p>
              
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-red-500 mr-2">•</span>
                    <span>Use the Site in any way that violates any applicable federal, state, or local law or regulation.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-500 mr-2">•</span>
                    <span>Provide any information that is false, misleading, or inaccurate.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-500 mr-2">•</span>
                    <span>Use the Site to transmit any unsolicited advertising or promotional material.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-500 mr-2">•</span>
                    <span>Engage in any conduct that could disable, overburden, damage, or impair the Site or interfere with any other party's use of the Site.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-500 mr-2">•</span>
                    <span>Use any robot, spider, or other automatic device, process, or means to access the Site for any purpose, including monitoring or copying any of the material on the Site.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-500 mr-2">•</span>
                    <span>Introduce any viruses, Trojan horses, worms, or other material that is malicious or technologically harmful.</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 6 */}
          <section id="intellectual-property">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Intellectual Property Rights</h2>
            <div className="space-y-4">
              <p>The Site and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by Masa Hills Health Services, its licensors, or other providers of such material and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p>
              
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-semibold text-blue-900 mb-2">Permitted Use</h3>
                <p className="text-blue-800">You are permitted to use the Site for your personal, non-commercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Site without our prior written consent.</p>
              </div>
            </div>
          </section>

          {/* Section 7 */}
          <section id="third-party">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Third-Party Links</h2>
            <div className="space-y-4">
              <p>If the Site contains links to other sites and resources provided by third parties (such as our web hosting provider), these links are provided for your convenience only. We have no control over the contents of those sites or resources and accept no responsibility for them or for any loss or damage that may arise from your use of them.</p>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="text-yellow-800 font-medium">If you decide to access any of the third-party websites linked to this Site, you do so entirely at your own risk and subject to the terms and conditions of use for such websites.</p>
              </div>
            </div>
          </section>

          {/* Section 8 */}
          <section id="warranties">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Disclaimer of Warranties</h2>
            <div className="bg-gray-100 border-2 border-gray-300 rounded-lg p-6">
              <div className="space-y-4 text-gray-800">
                <p className="font-semibold">YOU UNDERSTAND THAT WE CANNOT AND DO NOT GUARANTEE OR WARRANT THAT THE SITE WILL BE FREE OF VIRUSES OR OTHER DESTRUCTIVE CODE. YOUR USE OF THE SITE, ITS CONTENT, AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE IS AT YOUR OWN RISK. THE SITE, ITS CONTENT, AND ANY SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.</p>
                
                <p>NEITHER THE PRACTICE NOR ANY PERSON ASSOCIATED WITH THE PRACTICE MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE SITE. WITHOUT LIMITING THE FOREGOING, NEITHER THE PRACTICE NOR ANYONE ASSOCIATED WITH THE PRACTICE REPRESENTS OR WARRANTS THAT THE SITE OR ITS CONTENT WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED.</p>
                
                <p className="font-semibold">WE HEREBY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE.</p>
              </div>
            </div>
          </section>

          {/* Section 9 */}
          <section id="liability">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation on Liability</h2>
            <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6">
              <p className="text-red-800 font-semibold">TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL MASA HILLS HEALTH SERVICES, ITS AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE SITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE SITE, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, OR LOSS OF DATA, EVEN IF FORESEEABLE.</p>
            </div>
          </section>

          {/* Section 10 */}
          <section id="governing-law">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law and Jurisdiction</h2>
            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-semibold text-blue-900 mb-2">Governing Law</h3>
                <p className="text-blue-800">All matters relating to the Site and these Terms of Service, and any dispute or claim arising therefrom or related thereto, shall be governed by and construed in accordance with the internal laws of the State of Texas without giving effect to any choice or conflict of law provision or rule.</p>
              </div>
              
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <h3 className="font-semibold text-green-900 mb-2">Jurisdiction</h3>
                <p className="text-green-800">Any legal suit, action, or proceeding arising out of, or related to, these Terms of Service or the Site shall be instituted exclusively in the federal courts of the United States or the courts of the State of Texas, in each case located in the County of Dallas or Collin. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.</p>
              </div>
            </div>
          </section>

          {/* Section 11 */}
          <section id="changes">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to the Terms of Service</h2>
            <div className="space-y-4">
              <p>We may revise and update these Terms of Service from time to time in our sole discretion. All changes are effective immediately when we post them. Your continued use of the Site following the posting of revised Terms of Service means that you accept and agree to the changes.</p>
              
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                <p className="text-orange-800 font-medium">You are expected to check this page frequently, so you are aware of any changes, as they are binding on you.</p>
              </div>
            </div>
          </section>

          {/* Section 12 */}
          <section id="contact">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Information</h2>
            <p className="mb-4">To ask questions or comment about these Terms of Service, please contact us at:</p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h3 className="font-bold text-blue-900 mb-4">Masa Hills Health Services LLC</h3>
              <div className="space-y-3">
                <div className="flex items-center text-blue-800">
                  <MapPin className="h-5 w-5 mr-3 flex-shrink-0" />
                  <span>3410 Texas Dr, Sachse, Texas 75048</span>
                </div>
                <div className="flex items-center text-blue-800">
                  <Phone className="h-5 w-5 mr-3 flex-shrink-0" />
                  <span>(469) 573-0176</span>
                </div>
                <div className="flex items-center text-blue-800">
                  <Mail className="h-5 w-5 mr-3 flex-shrink-0" />
                  <a href="mailto:Contact@masahillshealthservices.com" className="hover:underline">
                    Contact@masahillshealthservices.com
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-gray-500 text-sm">
          <p>© 2025 Masa Hills Health Services LLC. All rights reserved.</p>
          <p className="mt-1">These terms of service are effective as of June 8, 2025.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;